import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  TextField,
  Checkbox,
  ListSubheader,
  Box,
  InputAdornment,
  Typography, Divider, Menu, MenuItem,
} from "@mui/material";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BarChartIcon from "@mui/icons-material/BarChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import CampaignIcon from "@mui/icons-material/Campaign";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Home } from '@mui/icons-material';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ConstructionIcon from '@mui/icons-material/Construction';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import InventoryIcon from '@mui/icons-material/Inventory';
import StyleIcon from '@mui/icons-material/Style';
import Logo from "../../../../stories/assets/wiseSenseLogoWhite.svg"; // Adjust the path to your actual logo file
import StarIcon from "@mui/icons-material/Star";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import LanguageIcon from "@mui/icons-material/Language";
import SearchIcon from "@mui/icons-material/Search";
import Tooltip from '@mui/material/Tooltip';
import { http } from "../../../../clients/http/http.client";
import { HTTP_ENDPOINTS } from "../../../../clients/clients.constants";
import { setSearchQuery, setSelectedOptions } from "../../../../store/alertsFiltersOptionsSlice";
import { WEB_STORAGE_KEYS } from "../../../../clients/clients.constants";
import InputText from "../../../Inputs/InputText/InputText";
import {useLocation, useNavigate} from "react-router-dom";
import {WebStorageClient} from "../../../../clients/webStorage.client";
import {isRouteVisible} from "../../../../utils";

const { OPTIONS } = HTTP_ENDPOINTS;

const SideNav = ({ drawerOpen }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const initialOptions = useSelector((state) => state.alertsFiltersOptions);

  const handleSearchChange = (filterName, query) => {
    dispatch(setSearchQuery({ filterName, query }));
  };

  const handleSelectionChange = (filterName, selectedOptions) => {
    dispatch(setSelectedOptions({ filterName, selectedOptions }));
  };

  const [locationName, setLocationName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openInventory, setOpenInventory] = useState(false);
  const [openMovements, setOpenMovements] = useState(false);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [openAnalytics, setOpenAnalytics] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null); // For pop-up menu anchor
  const [openFilters, setOpenFilters] = useState({
    brand: false,
    siteType: false,
    region: false,
    countryState: false
  });
  const drawerWidth = drawerOpen ? "250px" : "75px"; // Control width of the drawer
  const movementsPages = ['/asset-tracking', '/analytics'];

  // State to manage the selection of items and search query
  const [filterOptions, setFilterOptions] = useState(initialOptions);

  const commonListItemStyles = {
    cursor: 'pointer',
    color: "#FFFFFF", // Default text color (white)
    borderRadius: "8px",
    width: !drawerOpen ? "50px" : '100%',
    height: "40px",
    opacity: 0.7,
    backgroundColor: "transparent", // Transparent by default
    "& .MuiListItemIcon-root": {
      color: "#FFFFFF", // Default icon color (white)
      "& svg": {
        fontSize: "20px",
      },
    },
    "& .MuiTypography-root": {
      fontSize: "14px",
      display: !drawerOpen ? 'none' : 'block',
    },
    "&:hover": {
      opacity: 1,
      color: "#FFFFFF", // Text color on hover
      "& .MuiListItemIcon-root": {
        color: "#FFFFFF", // Icon color on hover
        opacity: 1
      },
      "& .MuiSvgIcon-root": {
        color: "#FFFFFF", // Ensure all icons turn white on hover
        opacity: 1
      },
    },

    "&.Mui-selected": {
      backgroundColor: "#fff", // Active item background color
      color: "#1B3665",
      opacity: 0.9,
      "& .MuiListItemIcon-root": {
        color: "#FFFFFF", // Active item icon color
      },
      "& .MuiSvgIcon-root": {
        color: "#1B3665",
        opacity: 1
      },
      "&:hover": {
        opacity: 1,
        "& .MuiSvgIcon-root": {
          color: "#1B3665",
          opacity: 1
        }
      },
    },
  };
  const collapseStyles = {
    '.MuiCollapse-wrapper': {
      '.MuiListItem-root': {
       '.MuiListItemText-root': {
         '.MuiTypography-root': {
           fontSize: '12px'
         }
       }
      }
    }
  };
  const [currentModal, setCurrentModal] = useState('');

  const handleMenuOpen = (event, currentModal) => {
    setMenuAnchorEl(event.currentTarget);
    setCurrentModal(currentModal);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleInventoryClick = (event, currentModal) => {
    if (drawerOpen) {
      setOpenInventory(!openInventory);
    } else {
      handleMenuOpen(event, currentModal);
    }
  };

  const handleMovementsClick = (event, currentModal) => {
    if (drawerOpen) {
      setOpenMovements(!openMovements);
    } else {
      handleMenuOpen(event, currentModal);
    }
  };

  const handleNotificationsClick = (event, currentModal) => {
    if (drawerOpen) {
      setOpenNotifications(!openNotifications);
    } else {
      handleMenuOpen(event, currentModal);
    }
  };

  const handleAnalyticsClick = (event, currentModal) => {
    if (drawerOpen) {
      setOpenAnalytics(!openAnalytics);
    } else {
      handleMenuOpen(event, currentModal);
    }
  };

  const handleFilterClick = (event, filterName) => {
    if (drawerOpen) {
      setOpenFilters((prevState) => ({
        ...prevState,
        [filterName]: !prevState[filterName],
      }));
    } else {
      handleMenuOpen(event, filterName);
    }
  };

  const handleSelectAll = (filterName) => {
    const allSelected =
      filterOptions[filterName].selected.length ===
      filterOptions[filterName].options.length;

    const selectedOptions = allSelected ? [] : [...filterOptions[filterName].options];

    setFilterOptions((prevState) => ({
      ...prevState,
      [filterName]: {
        ...prevState[filterName],
        selected: selectedOptions,
      },
    }));

    handleSelectionChange(filterName, selectedOptions);
  };

  useEffect(() => {
    localStorage.setItem(WEB_STORAGE_KEYS.ALERTS_FILTERS, JSON.stringify(initialOptions));
  }, [initialOptions])

  const handleOptionToggle = (filterName, option) => {
    setFilterOptions((prevState) => {
      const isSelected = prevState[filterName].selected.includes(option);
      const selectedOptions = isSelected
        ? prevState[filterName].selected.filter((item) => item !== option)
        : [...prevState[filterName].selected, option];

      handleSelectionChange(filterName, selectedOptions);

      return {
        ...prevState,
        [filterName]: {
          ...prevState[filterName],
          selected: selectedOptions,
        },
      };
    });
  };

  const handleSearch = (filterName, query) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      [filterName]: {
        ...prevState[filterName],
        searchQuery: query,
      },
    }));

    handleSearchChange(filterName, query);
  };

  const renderFilterOptions = (filterName) => {
    const filteredOptions = filterOptions[filterName].options.filter((option) =>
      option
        .toLowerCase()
        .includes(filterOptions[filterName].searchQuery.toLowerCase())
    );

    return filteredOptions.map((option) => (
      <ListItem
        sx={{ pl: 4 }}
        key={option}
        dense
        button
        onClick={() => handleOptionToggle(filterName, option)}
      >
        <Checkbox
          sx={{ color: drawerOpen ? '#FFF' : '#000', fontSize: '12px'}}
          edge="start"
          checked={filterOptions[filterName].selected.includes(option)}
          tabIndex={-1}
          disableRipple
        />
        <ListItemText
          sx={{
            ".MuiTypography-root": {
              fontSize: "12px",
            },
          }}
          primary={option}
        />
      </ListItem>
    ));
  };

  const fetchFilters = async () => {
    try {
      setIsLoading(true);
      const options = await http.client.get(OPTIONS);

      setFilterOptions((prevState) => ({
        ...prevState,
        brand: {
          ...prevState.brand,
          options: options.brand.map((item) => item.name),
        },
        siteType: {
          ...prevState.siteType,
          options: options.siteType.map((item) => item.name),
        },
        region: {
          ...prevState.region,
          options: options.region.map((item) => item.name),
        },
        countryState: {
          ...prevState.countryState,
          options: options.countryState.map((item) => item.name),
        },
        // siteId: {
        //   ...prevState.siteId,
        //   options: options.siteId.map((item) => item.name),
        // }
      }));
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      setError(e?.message || 'Something went wrong or server not responding');
    }
  };

  const renderFilterContent = (optionName, type = 'icon') => {
    switch (optionName) {
      case 'brand':
        return type === 'icon' ? <StarIcon /> : 'Brand'
      case 'siteType':
        return type === 'icon' ? <HomeWorkIcon /> : 'Site Type'
      case 'region':
        return type === 'icon' ? <LanguageIcon /> : 'Region'
      case 'countryState':
        return type === 'icon' ? <LanguageIcon /> : 'Country State'
      // case 'siteId':
      //   return type === 'icon' ? <LanguageIcon /> : 'Site ID'
    }
  }

  const onSubMenuClick = (page) => {
    if (drawerOpen && !openMovements) {
      setOpenMovements(true);
    }
    navigate(page);
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    if (drawerOpen && movementsPages.includes(locationName)) {
      setOpenMovements(true);
    }
  }, [drawerOpen, locationName]);

  useEffect(() => {
    console.log('location',location);
    setLocationName(`${location.pathname}${location.search}`);
  }, [location]);

  const [user, setUser] = useState(null);
  const userStore = useSelector((state) => state.user);
  useEffect(() => {
    if (user) {
      setUser(userStore.user);
    } else {
      setUser(null);
    }
  }, [userStore.user]);

  return (
    <>
      <Drawer
        variant="permanent"
        open={drawerOpen}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          transition: "width 0.3s",
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            transition: "width 0.3s",
            paddingTop: !drawerOpen ? "87px" : '17px',
            backgroundColor: "#1B3665", // Set the blue background color for the Drawer
            color: "#FFFFFF", // Ensure text color remains white
          },
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            display: drawerOpen ? 'block' : 'none',
            mx: "auto",
            my: 2,
            backgroundColor: "transparent",
          }}
        >
          <Box component="img" src={Logo} alt="WiseSense Logo" />
        </Box>

        <List
          sx={{
            padding: "10px",
            backgroundColor: "#1B3665",
            fontSize: "14px",
          }}
        >
          <Tooltip placement="right-start" className="nav-tooltip" title="Home">
            <ListItem
              className={locationName === '/home' ? 'Mui-selected' : ''}
              sx={{
                ...commonListItemStyles,
                display: isRouteVisible(userStore?.user?.roles, '/home') ? 'flex' : 'none',
              }}
              button
              onClick={() => navigate('/home')}
            >
              <ListItemIcon>
                <Home />
              </ListItemIcon>
              <ListItemText primary="Home" />
            </ListItem>
          </Tooltip>

          {/* Movements Dropdown */}
          {/*<Tooltip placement="right-start" className="nav-tooltip" title="Analytics">*/}
          {/*  <ListItem*/}
          {/*    button*/}
          {/*    sx={{*/}
          {/*      ...commonListItemStyles,*/}
          {/*      display: isRouteVisible(userStore?.user?.roles, '/analytics') ? 'flex' : 'none',*/}
          {/*    }}*/}
          {/*    className={locationName === '/analytics' ? 'Mui-selected' : ''}*/}
          {/*    onClick={() => onSubMenuClick('/analytics')}*/}
          {/*  >*/}
          {/*    <ListItemIcon>*/}
          {/*      <AnalyticsIcon />*/}
          {/*    </ListItemIcon>*/}
          {/*    <ListItemText primary="Analytics" />*/}
          {/*  </ListItem>*/}
          {/*</Tooltip>*/}

          <Tooltip placement="right-start" className="nav-tooltip" title="Shopping Carts">
            <ListItem
              className={locationName === '/asset-tracking?view=shopping-carts' ? 'Mui-selected' : ''}
              sx={{
                ...commonListItemStyles,
                display: isRouteVisible(userStore?.user?.roles, '/asset-tracking') ? 'flex' : 'none',
              }}
              button
              onClick={() => navigate('/asset-tracking?view=shopping-carts')}
            >
              <ListItemIcon>
                <ShoppingCartIcon />
              </ListItemIcon>
              <ListItemText primary="Shopping Carts" />
            </ListItem>
          </Tooltip>

          <Tooltip placement="right-start" className="nav-tooltip" title="Fixtures">
            <ListItem
              className={locationName === '/asset-tracking?view=fixtures' ? 'Mui-selected' : ''}
              sx={{
                ...commonListItemStyles,
                display: isRouteVisible(userStore?.user?.roles, '/asset-tracking') ? 'flex' : 'none',
              }}
              button
              onClick={() => navigate('/asset-tracking?view=fixtures')}
            >
              <ListItemIcon>
                <CheckroomIcon />
              </ListItemIcon>
              <ListItemText primary="Fixtures" />
            </ListItem>
          </Tooltip>

          <Tooltip placement="right-start" className="nav-tooltip" title="Backroom Material">
            <ListItem
              className={locationName === '/asset-tracking?view=backroom-material' ? 'Mui-selected' : ''}
              sx={{
                ...commonListItemStyles,
                display: isRouteVisible(userStore?.user?.roles, '/asset-tracking') ? 'flex' : 'none',
              }}
              button
              onClick={() => navigate('/asset-tracking?view=backroom-material')}
            >
              <ListItemIcon>
                <WarehouseIcon />
              </ListItemIcon>
              <ListItemText primary="Backroom Material" />
            </ListItem>
          </Tooltip>

          <Tooltip placement="right-start" className="nav-tooltip" title="ARRC Inventory">
            <ListItem
              className={locationName === '/asset-tracking?view=arrc-inventory' ? 'Mui-selected' : ''}
              sx={{
                ...commonListItemStyles,
                display: isRouteVisible(userStore?.user?.roles, '/asset-tracking') ? 'flex' : 'none',
              }}
              button
              onClick={() => navigate('/asset-tracking?view=arrc-inventory')}
            >
              <ListItemIcon>
                <InventoryIcon />
              </ListItemIcon>
              <ListItemText primary="ARRC Inventory" />
            </ListItem>
          </Tooltip>

          {/*/!* Movements Dropdown *!/*/}
          {/*<Tooltip placement="right-start" className="nav-tooltip" title="Movements">*/}
          {/*  <ListItem*/}
          {/*      sx={{...commonListItemStyles, display: isRouteVisible(userStore?.user?.roles, '/asset-tracking') ? 'flex' : 'none',}}*/}
          {/*      className={movementsPages.includes(locationName) ? 'Mui-selected' : ''}*/}
          {/*      button*/}
          {/*      onClick={(event) => handleMovementsClick(event, 'movements')}*/}
          {/*  >*/}
          {/*    <ListItemIcon>*/}
          {/*      <RoomPreferencesIcon />*/}
          {/*    </ListItemIcon>*/}
          {/*    <ListItemText primary="Movements" />*/}
          {/*    {drawerOpen ? openMovements ? <ExpandLess /> : <ExpandMore /> : ''}*/}
          {/*  </ListItem>*/}
          {/*</Tooltip>*/}
          {/*{*/}
          {/*  drawerOpen ? (*/}
          {/*      <Collapse in={openMovements} sx={collapseStyles} timeout="auto">*/}
          {/*        <List component="div" disablePadding>*/}
          {/*          <ListItem*/}
          {/*              button*/}
          {/*              sx={{ ...commonListItemStyles, pl: 4, mt: 1, cursor: 'pointer' }}*/}
          {/*              className={locationName === '/asset-tracking' ? 'Mui-selected' : ''}*/}
          {/*              onClick={() => onSubMenuClick('/asset-tracking')}*/}
          {/*          >*/}
          {/*            <ListItemText primary="Asset Tracking" />*/}
          {/*          </ListItem>*/}
          {/*          <ListItem*/}
          {/*              button*/}
          {/*              sx={{ ...commonListItemStyles, pl: 4, mt: 1, cursor: 'pointer' }}*/}
          {/*              className={locationName === '/analytics' ? 'Mui-selected' : ''}*/}
          {/*              onClick={() => onSubMenuClick('/analytics')}*/}
          {/*          >*/}
          {/*            <ListItemText primary="Analytics" />*/}
          {/*          </ListItem>*/}
          {/*        </List>*/}
          {/*      </Collapse>*/}
          {/*  ) : (*/}
          {/*      <Menu*/}
          {/*          anchorEl={menuAnchorEl}*/}
          {/*          open={Boolean(menuAnchorEl) && currentModal === 'movements'}*/}
          {/*          onClose={handleMenuClose}*/}
          {/*          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}*/}
          {/*          transformOrigin={{ vertical: 'top', horizontal: 'left' }}*/}
          {/*      >*/}
          {/*        <Typography*/}
          {/*            sx={{*/}
          {/*              marginBottom: '8px',*/}
          {/*              padding: '5px',*/}
          {/*              fontSize: '14px',*/}
          {/*              color: "#1B3665",*/}
          {/*              textAlign: 'center',*/}
          {/*              fontWeight: '600'*/}
          {/*            }}*/}
          {/*        >*/}
          {/*          Movements*/}
          {/*        </Typography>*/}
          {/*        <MenuItem button sx={{ fontSize: '12px', color: "#1B3665" }}>*/}
          {/*          Asset Tracking*/}
          {/*        </MenuItem>*/}
          {/*        <MenuItem button sx={{ fontSize: '12px', color: "#1B3665" }}>*/}
          {/*          Analytics*/}
          {/*        </MenuItem>*/}
          {/*      </Menu>*/}
          {/*  )*/}
          {/*}*/}
        </List>
        <Divider variant="middle"  sx={{ marginBottom: "14px", marginTop: "14px", background: '#FFF', opacity: 0.2 }} />
        <List sx={{ padding: '10px' }}>
          <Tooltip placement="right-start" className="nav-tooltip" title="Enrollment">
            <ListItem
              className={locationName.includes('enrollment') ? 'Mui-selected' : ''}
              sx={{
                ...commonListItemStyles,
                display: isRouteVisible(userStore?.user?.roles, '/enrollment') ? 'flex' : 'none',
              }}
              button
              onClick={() => navigate('/enrollment')}
            >
              <ListItemIcon>
                <StyleIcon />
              </ListItemIcon>
              <ListItemText primary="Enrollment" />
            </ListItem>
          </Tooltip>
        </List>
        {/*<Divider variant="middle"  sx={{ marginBottom: "24px", marginTop: "14px", background: '#FFF', opacity: 0.2 }} />*/}
        {/*<List sx={{ padding: "0 10px" }} >*/}
        {/*  <ListItem*/}
        {/*    sx={{*/}
        {/*      fontSize: '12px',*/}
        {/*      color: '#FFF',*/}
        {/*      opacity: 0.4,*/}
        {/*      textAlign: "center",*/}
        {/*      padding: !drawerOpen ? '0 0 17px 0' : '0 17px 17px 17px',*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    Sort & Filter*/}
        {/*  </ListItem>*/}
        {/*  {Object.keys(filterOptions).map((filterName) => (*/}
        {/*    <div key={filterName}>*/}
        {/*      <Tooltip placement="right-start" className="nav-tooltip" title={renderFilterContent(filterName, 'name')}>*/}
        {/*        <ListItem*/}
        {/*          sx={commonListItemStyles}*/}
        {/*          button*/}
        {/*          onClick={(event) => handleFilterClick(event, filterName)}*/}
        {/*        >*/}
        {/*          <ListItemIcon>*/}
        {/*            {renderFilterContent(filterName)}*/}
        {/*          </ListItemIcon>*/}
        {/*          <ListItemText primary={renderFilterContent(filterName, 'name')} />*/}
        {/*          {drawerOpen ? openFilters[filterName] ? <ExpandLess /> : <ExpandMore /> : ''}*/}
        {/*        </ListItem>*/}
        {/*      </Tooltip>*/}
        {/*      {*/}
        {/*        drawerOpen ? (*/}
        {/*          <Collapse in={openFilters[filterName]} sx={collapseStyles} timeout="auto" unmountOnExit>*/}
        {/*            <Box>*/}
        {/*              <ListItem*/}
        {/*                sx={{ pl: 4, color: "#FFF", display: 'flex', alignItems: 'center' }}*/}
        {/*                dense button*/}
        {/*                onClick={() => handleSelectAll(filterName)}*/}
        {/*              >*/}
        {/*                <Checkbox*/}
        {/*                  checked={*/}
        {/*                    filterOptions[filterName].selected.length ===*/}
        {/*                    filterOptions[filterName].options.length*/}
        {/*                  }*/}
        {/*                  sx={{ color: drawerOpen ? '#FFF' : '#000'}}*/}
        {/*                  edge="start"*/}
        {/*                  tabIndex={-1}*/}
        {/*                  disableRipple*/}
        {/*                />*/}
        {/*                <ListItemText*/}
        {/*                  primary="Select All"*/}
        {/*                  sx={{*/}
        {/*                    "& .MuiTypography-root": {*/}
        {/*                      fontSize: "12px",*/}
        {/*                    },*/}
        {/*                  }}*/}
        {/*                />*/}
        {/*              </ListItem>*/}
        {/*              <ListItem>*/}
        {/*                <InputText*/}
        {/*                  width="100%"*/}
        {/*                  onChangeFn={(value) => handleSearch(filterName, value) }*/}
        {/*                  value={filterOptions[filterName].searchQuery}*/}
        {/*                />*/}
        {/*              </ListItem>*/}
        {/*              {renderFilterOptions(filterName)}*/}
        {/*            </Box>*/}
        {/*          </Collapse>*/}
        {/*        ) : (*/}
        {/*          <Menu*/}
        {/*            anchorEl={menuAnchorEl}*/}
        {/*            open={Boolean(menuAnchorEl) && currentModal === filterName}*/}
        {/*            onClose={handleMenuClose}*/}
        {/*            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}*/}
        {/*            transformOrigin={{ vertical: 'top', horizontal: 'left' }}*/}
        {/*          >*/}
        {/*            <Typography*/}
        {/*              sx={{*/}
        {/*               marginBottom: '8px',*/}
        {/*                padding: '5px',*/}
        {/*                fontSize: '14px',*/}
        {/*                color: "#1B3665",*/}
        {/*                textAlign: 'center',*/}
        {/*                fontWeight: '600'*/}
        {/*              }}*/}
        {/*            >*/}
        {/*              {renderFilterContent(filterName, 'name')}*/}
        {/*            </Typography>*/}
        {/*            <Box>*/}
        {/*              <ListItem*/}
        {/*                sx={{ pl: 4, color: "#000" }}*/}
        {/*                dense button*/}
        {/*                onClick={() => handleSelectAll(filterName)}*/}
        {/*              >*/}
        {/*                <Checkbox*/}
        {/*                  checked={*/}
        {/*                    filterOptions[filterName].selected.length ===*/}
        {/*                    filterOptions[filterName].options.length*/}
        {/*                  }*/}
        {/*                  sx={{ transform: 'translateY(-1px)' }}*/}
        {/*                  edge="start"*/}
        {/*                  tabIndex={-1}*/}
        {/*                  disableRipple*/}
        {/*                />*/}
        {/*                <ListItemText*/}
        {/*                  primary="Select All"*/}
        {/*                  sx={{*/}
        {/*                    ".MuiTypography-root": {*/}
        {/*                      fontSize: "12px",*/}
        {/*                    },*/}
        {/*                  }}*/}
        {/*                />*/}
        {/*              </ListItem>*/}
        {/*              <ListItem>*/}
        {/*                <InputText*/}
        {/*                  width="100%"*/}
        {/*                  onChangeFn={(value) => handleSearch(filterName, value) }*/}
        {/*                  value={filterOptions[filterName].searchQuery}*/}
        {/*                />*/}
        {/*              </ListItem>*/}
        {/*              {renderFilterOptions(filterName)}*/}
        {/*            </Box>*/}
        {/*          </Menu>*/}
        {/*        )*/}
        {/*      }*/}
        {/*    </div>*/}
        {/*  ))}*/}
        {/*</List>*/}
      </Drawer>
    </>
  );
};

export default SideNav;
